import { monthEndAlertConstants } from './constant';

const {
  GET_MONTH_END_ALERTS_COUNT_REQUEST,
  GET_THEME_COUNT_REQUEST,
  GET_OWNER_ALERT_COUNT_REQUEST,
  GET_LIST_OF_MONTH_REQUEST,
  REQUEST_CERTIFY_ALERT,
  RESET_CERTIFY_ALERT,
  REQUEST_GET_STATUS_CERTIFY,
} = monthEndAlertConstants;

export const getMonthEndAlertCount = (payload: object) => {
  return {
    type: GET_MONTH_END_ALERTS_COUNT_REQUEST,
    payload,
  };
};

export const getThemeCount = (payload: object) => {
  return {
    type: GET_THEME_COUNT_REQUEST,
    payload,
  };
};

export const getOwnerAlertCount = (payload: object) => {
  return {
    type: GET_OWNER_ALERT_COUNT_REQUEST,
    payload,
  };
};

export const getListOfMonthAlertRequest = (payload: object) => {
  return {
    type: GET_LIST_OF_MONTH_REQUEST,
    payload,
  };
};

export const certifyAlertAction = (payload: object) => {
  return {
    type: REQUEST_CERTIFY_ALERT,
    payload,
  };
};

export const resetCertifyAction = () => {
  return {
    type: RESET_CERTIFY_ALERT,
  };
};

export const getCertificationStatus = (payload: object) => {
  return {
    type: REQUEST_GET_STATUS_CERTIFY,
    payload,
  };
};
